export const PARENT_SELECTOR = ".loading-blocker";
export const OVERLAY_CLASS = "modal__overlay";
export const STACKING_LAYERS_ID = "#stacking-layers";
export const ROOT_ID = "#root";
